/*
 *
 * Virtual Market
 * session-utils -> Funciones para manejo de sesión
 *
 * RYNDEM 2017
 *
 */

import protocols, { DEBUG } from 'common-protocols'
import _ from 'lodash'

const OBJECT_ID = 'session-utils'
const hostName = window.location.hostname;
//const port = hostName === 'localhost' ? 3000 : 7070; //DESARROLLO
const port = hostName === 'localhost' ? 3000 : 80; //PRODUCCION
const url = `http://${window.location.hostname}:${port}`;

/* ALMACENAMIENTO DE AJUSTES */
export function initializeSettingsStorage(initialData, startingTime, endTime) {

  DEBUG && console.log(OBJECT_ID + '@initializeSettingsStorage');

  const packedData = {

    token: initialData[0],
    navigation: {
      path: `${protocols.ROUTE_MARKET}${protocols.ROUTE_MARKET_INCLUSION}`,
    },
    accessGranted: true,
    startHour: startingTime,
    endHour: endTime,
    idSession: '',
    idMarket: '',
    combinacion: '',
    ticket: {},
    hasTicket: false,
    startingMoney: 0,
      idPais: 0,
      campaign: 0
  }

  DEBUG && console.log(OBJECT_ID + '@initializeSettingsStorage: Objeto a guardar en almacenamiento... ' + packedData);

  localStorage.setItem(protocols.STORAGE_SETTINGS, JSON.stringify(packedData));

}

export function initializeSettingsStorageAdmin(data) {

    DEBUG && console.log(OBJECT_ID + '@initializeSettingsStorageAdmin');

    const packedData = {

        token: data.token,
        userName: data.userName,
        startHour: data.start,
        endHour: data.end
    }

    DEBUG && console.log(OBJECT_ID + '@initializeSettingsStorageAdmin: Objeto a guardar en almacenamiento... ' + packedData);

    localStorage.setItem(protocols.STORAGE_SETTINGS_ADMIN, JSON.stringify(packedData));

}

export function retrieveSettingsStorage() {
  DEBUG && console.log(OBJECT_ID + '@retrieveSettingsStorage: inicio');

  const settings = localStorage.getItem(protocols.STORAGE_SETTINGS);

  if (!settings) {
    return undefined;
  }

  return JSON.parse(settings);
}

export function updateSettingsStorage(data, path) {
  DEBUG && console.log(OBJECT_ID + '@updateSettingsStorage: inicio');

  let packedData = retrieveSettingsStorage();

  if (packedData) {

    _.update(packedData, path, o => { return data; });

    DEBUG && console.log(OBJECT_ID + '@updateSettingsStorage: Actualizar almacenamiento de ajustes -> ', packedData);

    localStorage.setItem(protocols.STORAGE_SETTINGS, JSON.stringify(packedData));
  }

}

export function removeSettingsStorage() {
  DEBUG && console.log(OBJECT_ID + '@updateSettingsStorage: inicio');

  const packedData = retrieveSettingsStorage();

  if (packedData) {

    DEBUG && console.log(OBJECT_ID + '@removeSettingsStorage: Eliminando almacenamiento de ajustes -> ' + packedData);

    localStorage.removeItem(protocols.STORAGE_SETTINGS);
  }

}

/* ALMACENAMIENTO DE CUESTIONARIO DE INCLUSION */

export function initializeInclusionQuestionnaireStorage() {

  DEBUG && console.log(OBJECT_ID + '@initializeInclusionQuestionnaireStorage: inicio');

  const packedData = {

    step: 0,
    answers: []
  }

  DEBUG && console.log(OBJECT_ID + '@initializeInclusionQuestionnaireStorage: Objeto a guardar en almacenamiento... ' + packedData);

  localStorage.setItem(protocols.STORAGE_INCLUSION_QUESTIONNAIRE, JSON.stringify(packedData));

}

export function retrieveInclusionQuestionnaireStorage() {
  DEBUG && console.log(OBJECT_ID + '@retrieveInclusionQuestionnaireStorage: inicio');

  return JSON.parse(localStorage.getItem(protocols.STORAGE_INCLUSION_QUESTIONNAIRE));

}

export function updateInclusionQuestionnaireStorage(data, path) {
  DEBUG && console.log(OBJECT_ID + '@updateInclusionQuestionnaireStorage: inicio');

  let packedData = retrieveInclusionQuestionnaireStorage();

  if (packedData) {

    _.update(packedData, path, o => { return data; });

    DEBUG && console.log(OBJECT_ID + '@updateSettingsStorage: Actualizar almacenamiento de cuestionario de inclusión -> ' + packedData);

    localStorage.setItem(protocols.STORAGE_INCLUSION_QUESTIONNAIRE, JSON.stringify(packedData));
  }

}

export function removeInclusionQuestionnaireStorage() {
  DEBUG && console.log(OBJECT_ID + '@removeInclusionQuestionnaireStorage: inicio');

  let packedData = retrieveInclusionQuestionnaireStorage();

  if (packedData) {

    DEBUG && console.log(OBJECT_ID + '@removeInclusionQuestionnaireStorage: Eliminando almacenamiento de cuestionario de inclusión -> ' + packedData);

    localStorage.removeItem(protocols.STORAGE_INCLUSION_QUESTIONNAIRE);
  }

}

/* ALMACENAMIENTO DE CUESTIONARIO SOCIO DEMOGRAFICO */

export function initializeSocioQuestionnaireStorage() {

  DEBUG && console.log(OBJECT_ID + '@initializeSocioQuestionnaireStorage: inicio');

  const packedData = {

    step: 0,
    answers: []
  }

  DEBUG && console.log(OBJECT_ID + '@initializeSocioQuestionnaireStorage: Objeto a guardar en almacenamiento... ' + packedData);

  localStorage.setItem('sc_insp', JSON.stringify(packedData));

}

export function retrieveSocioQuestionnaireStorage() {
  DEBUG && console.log(OBJECT_ID + '@retrieveSocioQuestionnaireStorage: inicio');

  return JSON.parse(localStorage.getItem('sc_insp'));

}

export function updateSocioQuestionnaireStorage(data, path) {
  DEBUG && console.log(OBJECT_ID + '@updateSocioQuestionnaireStorage: inicio');

  let packedData = retrieveSocioQuestionnaireStorage();

  if (packedData) {

    _.update(packedData, path, o => { return data; });

    DEBUG && console.log(OBJECT_ID + '@updateSocioQuestionnaireStorage: Actualizar almacenamiento de cuestionario socio -> ' + packedData);

    localStorage.setItem('sc_insp', JSON.stringify(packedData));
  }

}

export function removeSocioQuestionnaireStorage() {
  DEBUG && console.log(OBJECT_ID + '@removeSocioQuestionnaireStorage: inicio');

  let packedData = retrieveSocioQuestionnaireStorage();

  if (packedData) {

    DEBUG && console.log(OBJECT_ID + '@removeSocioQuestionnaireStorage: Eliminando almacenamiento de cuestionario socio -> ' + packedData);

    localStorage.removeItem('sc_insp');
  }

}

/* ALMACENAMIENTO DE CUESTIONARIO DE SALIDA */

export function initializeExitQuestionnaireStorage() {

  DEBUG && console.log(OBJECT_ID + '@initializeExitQuestionnaireStorage');

  const packedData = {

    step: 0,
    answers: [],
    activo: true
  }

  DEBUG && console.log(OBJECT_ID + '@initializeSocioQuestionnaireStorage: Objeto a guardar en almacenamiento... ' + packedData);

  localStorage.setItem('ec_insp', JSON.stringify(packedData));

}

export function retrieveExitQuestionnaireStorage() {
  DEBUG && console.log(OBJECT_ID + '@retrieveExitQuestionnaireStorage');

  return JSON.parse(localStorage.getItem('ec_insp'));

}

export function updateExitQuestionnaireStorage(data, path) {
  DEBUG && console.log(OBJECT_ID + '@updateExitQuestionnaireStorage');

  let packedData = retrieveExitQuestionnaireStorage();

  if (packedData) {

    _.update(packedData, path, o => { return data; });

    DEBUG && console.log(OBJECT_ID + '@updateExitQuestionnaireStorage: Actualizar almacenamiento de cuestionario de salida -> ' + packedData);
    localStorage.setItem('ec_insp', JSON.stringify(packedData));
  }

}

export function removeExitQuestionnaireStorage() {
  DEBUG && console.log(OBJECT_ID + '@removeExitQuestionnaireStorage');

  let packedData = retrieveExitQuestionnaireStorage();

  if (packedData) {

    DEBUG && console.log(OBJECT_ID + '@removeExitQuestionnaireStorage: Eliminando almacenamiento de cuestionario de salida -> ' + packedData);
    localStorage.removeItem('ec_insp');
  }

}

/* ALMACENAMIENTO DE CUESTIONARIO DE SALIDA CAMPAÑA */

export function initializeCampaignQuestionnaireStorage() {

  DEBUG && console.log(OBJECT_ID + '@initializeCampaignQuestionnaireStorage');

  const packedData = {

    step: 0,
    answers: [],
    activo: true
  }

  DEBUG && console.log(OBJECT_ID + '@initializeCampaignQuestionnaireStorage: Objeto a guardar en almacenamiento... ' + packedData);

  localStorage.setItem('cc_insp', JSON.stringify(packedData));

}

export function retrieveCampaignQuestionnaireStorage() {
  DEBUG && console.log(OBJECT_ID + '@retrieveCampaignQuestionnaireStorage');

  return JSON.parse(localStorage.getItem('cc_insp'));

}

export function updateCampaignQuestionnaireStorage(data, path) {
  DEBUG && console.log(OBJECT_ID + '@updateCampaignQuestionnaireStorage');

  let packedData = retrieveCampaignQuestionnaireStorage();

  if (packedData) {

    _.update(packedData, path, o => { return data; });

    DEBUG && console.log(OBJECT_ID + '@updateCampaignQuestionnaireStorage: Actualizar almacenamiento de cuestionario de campaña -> ' + packedData);
    localStorage.setItem('cc_insp', JSON.stringify(packedData));
  }

}

export function removeCampaignQuestionnaireStorage() {
  DEBUG && console.log(OBJECT_ID + '@removeCampaignQuestionnaireStorage');

  let packedData = retrieveCampaignQuestionnaireStorage();

  if (packedData) {

    DEBUG && console.log(OBJECT_ID + '@removeCampaignQuestionnaireStorage: Eliminando almacenamiento de cuestionario de campaña -> ' + packedData);
    localStorage.removeItem('cc_insp');
  }

}

/* ALMACENAMIENTO DE PRODUCTOS */

export function initializeProductsStorage() {

  DEBUG && console.log(OBJECT_ID + '@initializeProductsStorage');

  const packedData = {

    products: {},
    timeQuestionnaire: '',
    timeBeverage: '',
    sTimeBeverages: '',
    eTimeBeverages: '',
    timeSnacks: '',
    sTimeSnacks: '',
    eTimeSnacks: '',
    timeCereals: '',
    sTimeCereals: '',
    eTimeCereals: '',
    timeDairyProducts: '',
    sTimeDairyProducts: '',
    eTimeDairyProducts: '',
    timeReadyToEat: '',
    sTimeReadyToEat: '',
    eTimeReadyToEat: '',
    sendMetrics: false,

  }

  DEBUG && console.log(OBJECT_ID + '@initializeProductsStorage: Objeto a guardar en almacenamiento... ' + packedData);

  localStorage.setItem('products_insp', JSON.stringify(packedData));

}

export function retrieveProductsStorage() {
  DEBUG && console.log(OBJECT_ID + '@retrieveProductsStorage');

  return JSON.parse(localStorage.getItem('products_insp'));

}

export function updateProductsStorage(data, path) {
  DEBUG && console.log(OBJECT_ID + '@updateProductsStorage');

  let packedData = retrieveProductsStorage();

  if (packedData) {

    _.update(packedData, path, o => { return data; });

    DEBUG && console.log(OBJECT_ID + '@updateProductsStorage: Actualizar almacenamiento de productos -> ' + packedData);
    localStorage.setItem('products_insp', JSON.stringify(packedData));
  }

}

export function removeProductsStorage() {
  DEBUG && console.log(OBJECT_ID + '@removeProductsStorage');

  let packedData = retrieveProductsStorage();

  if (packedData) {

    DEBUG && console.log(OBJECT_ID + '@removeProductsStorage: Eliminando almacenamiento de productos -> ' + packedData);
    localStorage.removeItem('products_insp');
  }

}

/* ALMACENAMIENTO DE MERCADO */

export function initializeMarketStorage() {

  DEBUG && console.log(OBJECT_ID + '@initializeMarketStorage');

  if (storageAvailable()) {

    let packedData = {

      activeDepartament: '',
      activeSection: protocols.SUMMARY_LABEL,
      activeOptionMenu: '',
      productsInCart: [],
      finishPurchase: {},
    }

    packedData = JSON.stringify(packedData);

    localStorage.setItem('vm_market', packedData);
  }
}

export function retrieveMarketStorage() {
  DEBUG && console.log(OBJECT_ID + '@retrieveMarketStorage');

  const products = JSON.parse(localStorage.getItem('vm_market'));
  return products;
}

export function updateMarketStorage(data, path) {

  DEBUG && console.log(OBJECT_ID + '@updateMarketStorage');

  let packedData = retrieveMarketStorage();

  if (packedData) {

    _.update(packedData, path, o => { return data; });

    packedData = JSON.stringify(packedData);

    DEBUG && console.log(OBJECT_ID + '@updateMarketStorage: Actualizar localStorage de productos -> ' + packedData);
    localStorage.setItem('vm_market', packedData);
  }

}

export function removeMarketStorage() {
  DEBUG && console.log(OBJECT_ID + '@removeMarketStorage');
  localStorage.removeItem('vm_market');
}


/* ALMACENAMIENTO DE METRICAS */

export function initializeMetricsStorage() {

  DEBUG && console.log(OBJECT_ID + '@initializeMetricsStorage');

  if (storageAvailable()) {

    let packedData = {

      startTimeSimulation: '',
      startTimeProductCheckout: '',
      firstTimeClick: -1,
      firstTimePurchase: -1,
      finishTimeCart: -1,
      timeShowProductAndBuy: [],
      timeShowProductAndNotBuy: [],
      numberOfTimeMouseOverImage: [],
      timeMouseOverImage: [],
      timeInProductCheckout: -1,
      timeTotal: -1,
      metrics: []
    }

    packedData = JSON.stringify(packedData);

    localStorage.setItem('vm_metrics', packedData);
  }
}

export function retrieveMetricsStorage() {
  DEBUG && console.log(OBJECT_ID + '@retrieveMetricsStorage');

  const metrics = JSON.parse(localStorage.getItem("vm_metrics"));
  return metrics;

}

export function updateMetricsStorage(data, path) {

  DEBUG && console.log(OBJECT_ID + '@updateMetricsStorage');

  let packedData = retrieveMetricsStorage();

  if (packedData) {

    _.update(packedData, path, o => { return data; });

    packedData = JSON.stringify(packedData);

    DEBUG && console.log(OBJECT_ID + '@updateMetricsStorage: Actualizar localStorage de métricas -> ' + packedData);


    localStorage.setItem('vm_metrics', packedData);
  }

}

export function removeMetricsStorage() {
  DEBUG && console.log(OBJECT_ID + '@removeMetricsStorage');

  localStorage.removeItem('vm_metrics');

}

/* ALMACENAMIENTO DE RESUMENES */

export function initializeSummaryStorage(previous = true) {

  DEBUG && console.log(OBJECT_ID + '@initializeSummaryStorage');

  if (storageAvailable()) {

    let packedData = {
      step: 0,
      answers: [],
      previous,
      activo: true
    }

    packedData = JSON.stringify(packedData);

    localStorage.setItem('vm_summaries', packedData);
  }
}

export function retrieveSummaryStorage() {
  DEBUG && console.log(OBJECT_ID + '@retrieveSummaryStorage');

  const metrics = JSON.parse(localStorage.getItem('vm_summaries'));
  return metrics;

}

export function updateSummaryStorage(data, path) {

  DEBUG && console.log(OBJECT_ID + '@updateSummaryStorage');

  let packedData = retrieveSummaryStorage();

  if (packedData) {

    _.update(packedData, path, o => { return data; });

    packedData = JSON.stringify(packedData);

    DEBUG && console.log(OBJECT_ID + '@updateSummaryStorage: Actualizar localStorage de resumenes -> ' + packedData);


    localStorage.setItem('vm_summaries', packedData);
  }

}

export function removeSummaryStorage() {
  DEBUG && console.log(OBJECT_ID + '@removeSummaryStorage');

  localStorage.removeItem('vm_summaries');

}

export function storageAvailable() {
  try {
    var storage = window['localStorage'],
    x = '__storage_test__';
    storage.setItem(x, x);
    storage.removeItem(x);
    return true;
  }
  catch(e) {
    return e instanceof DOMException && (
      // everything except Firefox
      e.code === 22 ||
      // Firefox
      e.code === 1014 ||
      // test name field too, because code might not be present
      // everything except Firefox
      e.name === 'QuotaExceededError' ||
      // Firefox
      e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
      // acknowledge QuotaExceededError only if there's something already stored
      storage.length !== 0;
  }
}

export function reloadApp() {
  DEBUG && console.log(OBJECT_ID + '@reloadApp: Refrescar pagina -> ');
  location.reload();
}

export function flushSession(toSpecificRoute = null) {
  DEBUG && console.log(OBJECT_ID + '@flushSession');

  //Eliminamos lo almacena en Local Storage
  localStorage.removeItem(protocols.STORAGE_SETTINGS);
  localStorage.removeItem(protocols.STORAGE_INCLUSION_QUESTIONNAIRE);
  localStorage.removeItem(protocols.STORAGE_SOCIO_QUESTIONNAIRE);
  localStorage.removeItem(protocols.STORAGE_EXIT_QUESTIONNAIRE);
  localStorage.removeItem(protocols.STORAGE_PRODUCTS);
  localStorage.removeItem(protocols.STORAGE_MARKET);
  localStorage.removeItem(protocols.STORAGE_METRICS);
  localStorage.removeItem(protocols.STORAGE_SUMMARIES);

  const newUrl =  toSpecificRoute ? `${url}${toSpecificRoute}` : `${url}${protocols.ROUTE_WELCOME}`;

  //Redirección a salida
  window.location.replace(newUrl);
}

export const entryCheck = (nextState, replace) => {

  DEBUG && console.log(OBJECT_ID + '@entryCheck');

  /*
  *  Check de estado de navegación para la primera entrada, si ya existe el dato almacenado ya
  *  estamos dentro de la prueba, redirigir a la ruta correspondiente, si no ir a bienvenida
  * */

  const packedData = retrieveSettingsStorage();

  if (typeof packedData === 'undefined') {
    DEBUG && console.log(OBJECT_ID + '@entryCheck: packedData es undefined');
    return;
  }

  DEBUG && console.log(OBJECT_ID + '@entryCheck: redirección');
  const route = packedData.navigation.path;
  replace(route);
}

export const getCurrentRouteFromStorage = (nextState, replace) => {

  DEBUG && console.log(OBJECT_ID + '@getCurrentRouteFromStorage: inicio');
  const packedData = retrieveSettingsStorage();

  if (typeof packedData === 'undefined') {
    DEBUG && console.log(OBJECT_ID + '@getCurrentRouteFromStorage: packedData es undefined');
    replace(`${protocols.ROUTE_WELCOME}`);
    return;
  }

  const route = packedData.navigation.path;

  if (route === nextState.location.pathname) {
    DEBUG && console.log(OBJECT_ID + '@getCurrentRouteFromStorage: es la misma ruta, déjalo pasar');
    return;
  }

  DEBUG && console.log(OBJECT_ID + '@getCurrentRouteFromStorage: redirigido a: ' + route);
  replace(route);

};

export function retrieveSettingsStorageAdmin() {
    DEBUG && console.log(OBJECT_ID + '@retrieveSettingsStorageAdmin: inicio');

    const settings = localStorage.getItem(protocols.STORAGE_SETTINGS_ADMIN);

    if (!settings) {
        return undefined;
    }

    return JSON.parse(settings);
}

export function updateAdminSettingsStorage(data, path) {
  DEBUG && console.log(OBJECT_ID + '@updateAdminSettingsStorage: inicio');

  let packedData = retrieveSettingsStorageAdmin();

  if (packedData) {

    _.update(packedData, path, o => { return data; });

    DEBUG && console.log(OBJECT_ID + '@updateAdminSettingsStorage: Actualizar almacenamiento de ajustes de administrador -> ', packedData);

    localStorage.setItem(protocols.STORAGE_SETTINGS_ADMIN, JSON.stringify(packedData));
  }

}

export const getTokenAdminFromStorage = (nextState, replace) => {

    DEBUG && console.log(OBJECT_ID + '@getTokenAdminFromStorage: inicio');

    const packedData = retrieveSettingsStorageAdmin();

    //Si localstorage esta vacio se manda al login
    if (typeof packedData === 'undefined') {
        if (nextState.location.pathname === protocols.ROUTE_LOGIN_ADMIN) {
            return;
        }
        DEBUG && console.log(OBJECT_ID + '@getTokenAdminFromStorage: packedData es undefined');
        replace(`${protocols.ROUTE_LOGIN_ADMIN}`);
        return;
    }

    //Si se trata de ir al login, pero el localstorage tiene algo, se manda a home
    if (nextState.location.pathname === protocols.ROUTE_LOGIN_ADMIN) {
        DEBUG && console.log(OBJECT_ID + '@getTokenAdminFromStorage: packedData no es undefined');
        replace(`${protocols.ROUTE_HOME_ADMIN}`);
        return;
    }

    return;
};

export function flushSessionAdmin() {
    DEBUG && console.log(OBJECT_ID + '@flushSessionAdmin');

    //Eliminamos lo almacena en Local Storage
    localStorage.removeItem(protocols.STORAGE_SETTINGS_ADMIN);

    const newUrl =  `${url}${protocols.ROUTE_LOGIN_ADMIN}`;

    //Redirección a salida
    window.location.replace(newUrl);
}

export function defineLastPathToRedirect(path){
  let routeToRedirect;
  switch(path){
    case "SocioDemografico":
      routeToRedirect = '/mercado_virtual/prueba/cuestionario_sociodemografico';
      break;
    case "Asentimiento":
      routeToRedirect = '/mercado_virtual/prueba/cuestionario_sociodemografico';
      break;
    case "MenosSaludable":
        routeToRedirect = '/mercado_virtual/prueba/simulacion';
        break;
    case "Simulacion":
      routeToRedirect = '/mercado_virtual/prueba/simulacion';
      break;
    case "ResumenCompra":
      routeToRedirect = '/mercado_virtual/prueba/simulacion';
      break;
    case "CuestionarioCampana":
    case "CuestionarioSalida":
      routeToRedirect = '/mercado_virtual/prueba/cuestionario_salida';
      break;
    case "Resumen":
      routeToRedirect = '/mercado_virtual/prueba/resumen';
      break;
    default:
      routeToRedirect = '/mercado_virtual/login';
  }
  return routeToRedirect;
}

/* ALMACENAMIENTO DE ESTADOS DE CUESTIONARIO */

export function guardarEstadoCuestionarios(estadoCuestionarios) {

  DEBUG && console.log(OBJECT_ID + '@guardarEstadoCuestionarios');

  if (storageAvailable()) {

    let packedData = estadoCuestionarios

    packedData = JSON.stringify(packedData);

    localStorage.setItem('estado_cuestionarios', packedData);
  }
}

export function recuperarEstadoCuestionarios() {
  DEBUG && console.log(OBJECT_ID + '@recuperarEstadoCuestionarios');

  const estadoCuestionarios = JSON.parse(localStorage.getItem('estado_cuestionarios'));
  return estadoCuestionarios;
}

export function borrarEstadoCuestionarios() {
  DEBUG && console.log(OBJECT_ID + '@borrarEstadoCuestionarios');

  localStorage.removeItem('estado_cuestionarios');

}


// WEBPACK FOOTER //
// ./src/utilities/session-utils.js